var map = {
	"./arg.svg": 727,
	"./aus.svg": 728,
	"./bel.svg": 729,
	"./bra.svg": 730,
	"./can.svg": 731,
	"./cmr.svg": 732,
	"./crc.svg": 733,
	"./cro.svg": 734,
	"./den.svg": 735,
	"./ecu.svg": 736,
	"./eng.svg": 737,
	"./esp.svg": 738,
	"./fra.svg": 739,
	"./ger.svg": 740,
	"./gha.svg": 741,
	"./irn.svg": 742,
	"./jpn.svg": 743,
	"./kor.svg": 744,
	"./ksa.svg": 745,
	"./mar.svg": 746,
	"./mex.svg": 747,
	"./ned.svg": 748,
	"./pol.svg": 749,
	"./por.svg": 750,
	"./qat.svg": 751,
	"./sen.svg": 752,
	"./srb.svg": 753,
	"./sui.svg": 754,
	"./tun.svg": 755,
	"./uru.svg": 756,
	"./usa.svg": 757,
	"./wal.svg": 758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;